import { createStore } from 'vuex';
import productState from './modules/ProductList';

const store = createStore({
  modules: {
    productState,
    // other store modules if needed
  },
});

export default store;
